import { FloorMapType } from './types/FloorMap';

export default function isFloorMapValid(floorMap: FloorMapType) {
  return floorMap.placement.coordinates.length === 4;
}
